import React from 'react'

import { useShouldHideColors } from './options/_form/PdfOptionsFormHandler'
import { COLORS } from '@btime/constants'

const GridBar = ({ children, justify, direction, align }) => {
  const hideColors = useShouldHideColors()

  const styles = {
    root: {
      display: 'flex',
      flexDirection: direction || 'row',
      justifyContent: justify || 'flex-start',
      alignItems: align || 'center',
      border: `solid 1px ${hideColors ? COLORS.dark1 : COLORS.light1}`,
      backgroundColor: hideColors ? COLORS.transparent : COLORS.light1,
      borderRadius: 3,
      padding: 5,
      margin: -5
    }
  }

  return (
    <div className="grid-bar" style={styles.root}>
      {children}
    </div>
  )
}

export default GridBar
